import React from 'react';
import { ScheduleShift as JobsiteScheduleShiftType } from 'containers/jobsite/tabs/jobsiteSchedules/data/types';
import { ScheduleStatus } from 'apollo/generated/client-operations';
import { useJobsiteSchedules } from './jobsiteSchedulesProvider';
import { ScheduleWorkersTable } from './scheduleWorkersTable';
import { ScheduleAttendanceTable } from './scheduleAttendanceTable';
import { JobsiteScheduleShiftHeader } from './JobsiteScheduleShiftHeader';

export function JobsiteScheduleShift({
  shift,
}: {
  shift: JobsiteScheduleShiftType;
}): React.ReactElement {
  const { selectedSchedule } = useJobsiteSchedules();

  return (
    <div className="odin-flex odin-flex-col odin-gap-2" key={shift.id}>
      <JobsiteScheduleShiftHeader shift={shift} />
      {selectedSchedule?.status === ScheduleStatus.Completed ? (
        <ScheduleAttendanceTable shift={shift} />
      ) : (
        <ScheduleWorkersTable shift={shift} />
      )}
    </div>
  );
}
